module.exports = __webpack_public_path__ + "static/media/HTC One A9 White.e15f8cd6.png";